import { create } from 'zustand';
import { resolveErrorKey } from '@/infrastructure/util/error';
import type { Course } from '@/domain/model/Course';
import type { Subcategory } from '@/domain/model/Subcategory';
import { CourseService } from '@/application/service/CourseService';
import { CourseApiAdapter } from '@/infrastructure/api/CourseApiAdapter';
import { CatalogService } from '@/application/service/CatalogService';
import { CatalogApiAdapter } from '@/infrastructure/api/CatalogApiAdapter';

interface CourseState {
  currentCourse: Course | null;
  currentSubcategory: Subcategory | null;
  isLoading: boolean;
  error: string | null;
}

interface CourseActions {
  fetchCourseAndSubcategory: (courseId: string, subcategoryId: string) => Promise<void>;
  clearCourse: () => void;
}

const courseService = new CourseService(new CourseApiAdapter());
const catalogService = new CatalogService(new CatalogApiAdapter());

export const useCourseStore = create<CourseState & CourseActions>((set) => ({
  currentCourse: null,
  currentSubcategory: null,
  isLoading: false,
  error: null,

  fetchCourseAndSubcategory: async (courseId, subcategoryId) => {
    set({ isLoading: true, error: null });
    try {
      const [course, subcategory] = await Promise.all([
        courseService.getCourse(courseId),
        catalogService.getSubcategory(subcategoryId),
      ]);
      set({ currentCourse: course, currentSubcategory: subcategory, isLoading: false });
    } catch (e) {
      set({ isLoading: false, error: resolveErrorKey(e, 'coursePlayer.loadFailed') });
    }
  },

  clearCourse: () => set({ currentCourse: null, currentSubcategory: null, error: null }),
}));
